import * as React from 'react';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { PageHeader } from '../../designSystem/PageHeader';
import { EmployeePageWrapper } from '../_pageWrappers/EmployeePageWrapper';
import { CardButton } from '../../designSystem/CardButton';
import { applicationEndpoints } from '../../amorg-common/applicationEndpoints';
import { Flex, FlexItem, Grid } from '../../designSystem/compositeComponents/FlexHelpers';
import { H2, H3 } from '../../designSystem/typography/Heading';
import { Redirect } from 'react-router-dom';
import { Card } from '../../designSystem/Card';
import { Icon } from '../../designSystem/icons/Icons';
import { colors } from '../../designSystem/colors/color';
import { IncidentIcon } from '../../designSystem/compositeComponents/IncidentIcon';
import { IncidentType } from '../../amorg-common';

// type loginMethod = 'none' |'magicLink';

export function PortalHomePage(): JSX.Element
{
    return (
        <EmployeePageWrapper>
            <PortalHomePageContent />
        </EmployeePageWrapper>
    );
}

function PortalHomePageContent(): JSX.Element
{
    const [redirectUrl, setRedirectUrl] = React.useState('');

    return (
        <>
            {redirectUrl !== '' &&
                <Redirect push to={redirectUrl} />
            }

            <SingleColumnLayout
                noDivider
                headerContainer={
                    <PageHeader headerText={`Velkommen til arbejdsmiljøportalen`} headerStyle='primary-black' />
                }
                contentContainer={
                    <>
                        <Flex flexDirection='column' gap={16}>
                        <H2>Foretag en indberetning</H2>
                        <Card variant='lightGray'>
                            <Grid gap={16} gridTemplateColumns={2} gridTemplateRows={2}>

                                <IncidentCardButton type="issue"
                                    header="Arbejdsmiljø-hændelse/problem"
                                    description="Her kan du indrapportere hændelser og udfordringer, der vedrører arbejdsmiljøet. Det kan være alt fra manglende udstyr og fysiske fejl i omgivelserne til behov for ændrede arbejdsgange."
                                    onClick={() => setRedirectUrl(applicationEndpoints.portal_incidents_type.replace(':type', 'issue'))}
                                />

                                <IncidentCardButton type="almost-accident"
                                    header="Nærved-ulykke"
                                    description="Her registrerer du nærved-ulykker – situationer hvor noget kunne være gået galt, eller næsten gjorde det. Formålet er at forebygge ulykker ved at lære af hændelserne."
                                    onClick={() => setRedirectUrl(applicationEndpoints.portal_incidents_type.replace(':type', 'almost-accident'))}
                                />
        
                                <IncidentCardButton type="work-injury"
                                    header="Arbejdsskade"
                                    description="Hvis du har været udsat for en arbejdsulykke, der har resulteret i en skade, skal den indberettes. Det kan være alt fra mindre skader til alvorlige ulykker."
                                    onClick={() => setRedirectUrl(applicationEndpoints.portal_incidents_type.replace(':type', 'work-injury'))}
                                />
                                    

                                <IncidentCardButton type='whistleblower'
                                    header='Whistleblower'
                                    description='Her kan du indsende en whistleblower-rapport, hvis du har oplysninger om alvorlige forhold, som bør undersøges nærmere.'
                                    onClick={() => setRedirectUrl(applicationEndpoints.portal_incidents_type.replace(':type', 'whistleblower'))}
                                />

                            </Grid>
                        </Card>
                        </Flex>


                        
                        <CardButton variant='outlined' onClick={() => setRedirectUrl(applicationEndpoints.portal_organization)}>
                            <Flex alignItems='center' gap={16}>
                                <Icon name="graph" size='large' color={colors.icon.info} />
                                <FlexItem flexGrow='1'>
                                    <H3>Har du brug for en arbejdsmiljøkollega?</H3>
                                    <div>...eller har du andre spørgsmål? Kontakt din arbejdsmiljøorganisation her.</div>
                                </FlexItem>
                                <div>
                                    <Icon name="arrows_chevron_chevronForward" size='medium' color={colors.icon.info} />
                                </div>
                            </Flex>
                        </CardButton>

                        <CardButton variant='outlined' onClick={() => setRedirectUrl(applicationEndpoints.portal_files)}>
                            <Flex alignItems='center' gap={16}>
                                <Icon name="interface_actions_download" size='large' color={colors.icon.info} />
                                <FlexItem flexGrow='1'>
                                    <H3>Delte dokumenter</H3>
                                    <div>Se og hent dokumenter med relevans for dig</div>
                                </FlexItem>
                                <div>
                                    <Icon name="arrows_chevron_chevronForward" size='medium' color={colors.icon.info} />
                                </div>
                            </Flex>
                        </CardButton>

                        {/* <Flex>
                            <CardButton variant='outlined' style={{ flex:1}}>
                                Arbejdspladsvurdering
                            </CardButton>

                            <CardButton variant='outlined' style={{ flex:1}}>
                                Møder i din arbejdsmiljøorganisation
                            </CardButton>
                        </Flex> */}

                </>
                }
            />
        </>
        
    );
}


type IncidentCardButtonProps = {
    type:IncidentType,
    header:string,
    description:string,
    onClick: () => void
}
function IncidentCardButton(props:IncidentCardButtonProps):JSX.Element
{
    return (
        <CardButton variant='outlined' onClick={props.onClick}>
            <Flex flexDirection='column' gap={4}>
                <IncidentIcon type={props.type} />
                <FlexItem flexGrow='1'>
                    <H3>{props.header}</H3>
                    <div>{props.description}</div>
                </FlexItem>
            </Flex>
        </CardButton>
    );
}